import * as React from 'react'
import { render, findDOMNode, unmountComponentAtNode } from "react-dom";
import {
  addDefaultPrefixToPropTypes,
  collectUncontrolledAndControlledProps,
  default as enhanceElement,
} from "react-google-maps/lib/enhanceElement";
import { MAP } from 'react-google-maps/lib/constants';

function createControlElement(props) {
  const containerElement = document.createElement(`div`);
  // Allow developers to style the "hidden element" via `props.inputProps` and `props.input{*}`.
  const component = render(props.children, containerElement);
  // Cannot directly use the component - Google Maps will mess with React's internal state
  // by detaching/attaching.
  const inputEl = findDOMNode(component).cloneNode(true);
  //unmountComponentAtNode(containerElement);
  //return inputEl;
  return component;
}

/*
 * function getInstanceFromComponent(component) {
 *   return component.state[SEARCH_BOX];
 * }*/

function mountElementToControlPositionOnMap(el, controlPosition, map) {
  return map.controls[controlPosition].push(el) - 1;
}

function unmountElementFromControlPositionOnMap(index, controlPosition, map) {
  return map.controls[controlPosition].removeAt(index);
}

//@enhanceElement(getInstanceFromComponent)
class GoogleMapControl extends React.Component< any, any> {
  static childContextTypes = {[MAP]: React.PropTypes.object };
  element = null;
  mountIndex = null;

  componentWillMount() {
    this.element = createControlElement(this.props);
  }

  componentDidMount() {
    this.mountIndex = mountElementToControlPositionOnMap(
      this.element,
      this.props.controlPosition,
      this.props.map.context[MAP],
    );
  }

  componentDidUpdate(prevProps) {
    if (this.props.controlPosition !== prevProps.controlPosition) {
      unmountElementFromControlPositionOnMap(
        this.mountIndex,
        prevProps.controlPosition,
        this.props.map.context[MAP],
      );
      this.mountIndex = mountElementToControlPositionOnMap(
        this.element,
        this.props.controlPosition,
        this.props.map.context[MAP],
      );
    }
  }

  componentWillUnmount() {
    if (this.mountIndex) {
      unmountElementFromControlPositionOnMap(
        this.mountIndex,
        this.props.controlPosition,
        this.props.map.context[MAP],
      );
      this.element = null;
    }
  }

  render() { return null; }
}

export { GoogleMapControl }



// WEBPACK FOOTER //
// ./src/app/components/SearchMap/GoogleMapControl.tsx